var _mask, _path, _path2, _circle, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 56,
    viewBox: "0 0 44 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_201_2",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 40,
    height: 52,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2,
    y: 2,
    width: 40,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0075 38.585C35.4674 35.8522 40 29.4554 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 29.4554 8.53261 35.8522 14.9925 38.585L21.1055 50.8111C21.4741 51.5482 22.5259 51.5482 22.8944 50.8111L29.0075 38.585Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0075 38.585C35.4674 35.8522 40 29.4554 40 22C40 12.0589 31.9411 4 22 4C12.0589 4 4 12.0589 4 22C4 29.4554 8.53261 35.8522 14.9925 38.585L21.1055 50.8111C21.4741 51.5482 22.5259 51.5482 22.8944 50.8111L29.0075 38.585Z",
    fill: "url(#paint0_linear_201_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0075 38.585L28.2282 36.7431L27.5486 37.0306L27.2186 37.6906L29.0075 38.585ZM14.9925 38.585L16.7814 37.6906L16.4514 37.0306L15.7717 36.7431L14.9925 38.585ZM21.1055 50.8111L19.3167 51.7055L19.3167 51.7055L21.1055 50.8111ZM22.8944 50.8111L24.6833 51.7056L24.6833 51.7056L22.8944 50.8111ZM38 22C38 28.6239 33.9744 34.3122 28.2282 36.7431L29.7867 40.427C36.9604 37.3922 42 30.287 42 22H38ZM22 6C30.8366 6 38 13.1634 38 22H42C42 10.9543 33.0457 2 22 2V6ZM6 22C6 13.1634 13.1634 6 22 6V2C10.9543 2 2 10.9543 2 22H6ZM15.7717 36.7431C10.0256 34.3122 6 28.6239 6 22H2C2 30.2869 7.0396 37.3922 14.2133 40.427L15.7717 36.7431ZM13.2037 39.4794L19.3167 51.7055L22.8944 49.9167L16.7814 37.6906L13.2037 39.4794ZM19.3167 51.7055C20.4223 53.9167 23.5777 53.9167 24.6833 51.7056L21.1055 49.9167C21.4741 49.1796 22.5259 49.1797 22.8944 49.9167L19.3167 51.7055ZM24.6833 51.7056L30.7963 39.4795L27.2186 37.6906L21.1055 49.9167L24.6833 51.7056Z",
    fill: "white",
    mask: "url(#path-1-outside-1_201_2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 14,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13C17.0371 13 13 17.0371 13 22C13 26.9629 17.0371 31 22 31C26.9629 31 31 26.9629 31 22C31 17.0371 26.9629 13 22 13ZM22 14.5C26.1514 14.5 29.5 17.8486 29.5 22C29.5 23.7988 28.8613 25.4453 27.8125 26.7344L17.2656 16.1875C18.5547 15.1387 20.2012 14.5 22 14.5ZM16.1875 17.2656L26.7344 27.8125C25.4453 28.8613 23.7988 29.5 22 29.5C17.8486 29.5 14.5 26.1514 14.5 22C14.5 20.2012 15.1387 18.5547 16.1875 17.2656Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_201_2",
    x1: 22,
    y1: 4,
    x2: 22,
    y2: 51.3639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.b43f1bb48d8bf6efbb7ce8f4299baabb.svg";
export { ForwardRef as ReactComponent };